//import jQuery from 'jquery';
//window.$ = jQuery;

//import * as bootstrap from 'bootstrap'
//window.bootstrap = bootstrap;

//import './pusher.min.js';
//import * as Pusher from "pusher"

//import * as Common from 'resources/js/common.js';
import * as Common from './common.js';
window.Common = Common;
